import type { Instance } from 'mobx-state-tree';
import { types } from 'mobx-state-tree';

import { CoreModel } from 'watchtower-ui/models/Core';
import { ExperimentsModel } from 'watchtower-ui/models/Experiments';
import { ScenariosModel } from 'watchtower-ui/models/Scenarios';

export const RootModel = types.model('Root').props({
  core: types.optional(CoreModel, {}),
  scenarios: types.optional(ScenariosModel, {}),
  experiments: types.optional(ExperimentsModel, {}),
});

export interface IRootModel extends Instance<typeof RootModel> {}
